/* eslint-disable indent,no-mixed-spaces-and-tabs */
import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {Switch, Route, Redirect} from 'react-router-dom';
import classNames from 'classnames';
import {connect, useSelector} from "react-redux";
import {Header, Sidebar} from '../../components/index.component';
import dashboardRoutes from '../../routes/dashboard';
import appStyle from '../../assets/jss/material-dashboard-react/appStyle';
import logo from '../../assets/img/side_bar.png';
import CustomRouter from '../../libs/CustomRouter.utils';
import DashboardSnackbar from '../../components/Snackbar.component';
import {makeStyles} from "@material-ui/styles";
import EventEmitter from "../../libs/Events.utils";
import Constants from "../../config/constants";
import {getTokenFcm, initializeFirebase} from '../../libs/PushNotifications';
import {serviceCaptureInfo, serviceGetPendingCounts} from "../../services/Common.service";
import RolesUtils from "../../libs/Roles.utils";
import {connectToSocket, disconnectSocket, getSocketInstance} from "../../libs/SocketUtils";
import LogUtils from "../../libs/LogUtils";
import history from "../../libs/history.utils";
import {getBrowserDeviceId} from '../../libs/general.utils';
import { useMediaQuery } from '@material-ui/core';
import FloatingChat from '../../components/FloatingChat/FloatingChat.component';
const useStyles = makeStyles(appStyle);

const Dashboard = ({title, ...props}) => {
    const classes = useStyles();
    const [mobileOpen, setMobileOpen] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(true);
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState('');
    const {user_profile, role, user} = useSelector(state => state.auth);
    const mainPanelRef = useRef(null);
    const justOpenedSidebar = useRef(false);
    const [isVisible, setIsVisible] = useState(!document.hidden);
    const isMobileView = useMediaQuery("(max-width:1250px)");
    const [pendingCounts, setPendingCounts] = useState({});

    // Add this to your main application code
    // navigator.serviceWorker.addEventListener('message', function(event) {
    //     if (event.data.type === 'SW_LOG') {
    //         const timestamp = event.data.timestamp;
    //         const logType = event.data.logType;
    //         const message = event.data.message;

    //         switch(logType) {
    //             case 'error':
    //                 console.error(`[SW ${timestamp}]`, ...message);
    //                 break;
    //             case 'warn':
    //                 console.warn(`[SW ${timestamp}]`, ...message);
    //                 break;
    //             default:
    //                 console.log(`[SW ${timestamp}]`, ...message);
    //         }
    //     }
    // });

    // useEffect(() => {
    //  document.body.style.overflow = 'hidden';
    //  document.body.style.position = 'fixed';
    //  return () => {
    //    document.body.style.overflow = '';
    //    document.body.style.position = '';
    //  };
    // }, []);

    useEffect(() => {
        const isMobile = window.innerWidth <= 768;
        const handleVisibilityChange = () => {
            if (isMobile) {
                if (!document.hidden) {
                    connectToSocket(user?.token, user?.id);
                    // if (window.CURRENT_SOCKET_ROOM) {
                    // const socket = getSocketInstance?.();
                    // socket?.emit(Constants.SOCKET_EVENT.SUBSCRIBE, window.CURRENT_SOCKET_ROOM);
                    // }
                } else {
                    if (window?.location?.pathname === '/messaging') {
                        // history.replace(`/mobile/dashboard`);
                    }
                    disconnectSocket();
                }
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    const fetchPendingCounts = useCallback(() => {
        serviceGetPendingCounts().then((res) => {
            if (!res.error) {
                setPendingCounts(res.data || {});
            }
        });
    }, []);

    useEffect(() => {
        fetchPendingCounts();
        EventEmitter.subscribe(EventEmitter.REFRESH_PENDING_COUNTS, fetchPendingCounts);
        return () => {
            EventEmitter.unsubscribe(EventEmitter.REFRESH_PENDING_COUNTS);
        }
    }, [fetchPendingCounts]);

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        EventEmitter.subscribe(EventEmitter.MOVE_TO_TOP, moveToTop);
        initializeFirebase();
        getTokenFcm().then((token) => {
            if (token) {
                const deviceId = getBrowserDeviceId();
                serviceCaptureInfo({
                    fcm_token: token,
                    device_id: deviceId
                });
            }
        });
        return () => {
            EventEmitter.unsubscribe(EventEmitter.MOVE_TO_TOP);
            window.removeEventListener('resize', handleResize);
            disconnectSocket();
        }
    }, []);

    useEffect(() => {
        const isMobile = window.innerWidth <= 768;
        const queryParams = new URLSearchParams(props.location?.search || window.location.search);
        const shouldOpenSidebar = queryParams.get('openSidebar') === 'true';

        if (shouldOpenSidebar) {
            setDrawerOpen(true);
            justOpenedSidebar.current = true;
            queryParams.delete('openSidebar');
            const searchString = queryParams.toString();
            const newUrl = (props.location?.pathname || window.location.pathname) + (searchString ? `?${searchString}` : '');
            history.replace(newUrl);
        } else if (isMobile) {
            if (justOpenedSidebar.current) {
                justOpenedSidebar.current = false;
            } else {
                setDrawerOpen(false);
            }
        }

        if (isMobile) {
            const currentPath = props.location?.pathname || window.location.pathname;
            if (!sessionStorage.getItem('hasSeenLandingPage') && (currentPath === '/' || currentPath === '/emp/home')) {
                sessionStorage.setItem('hasSeenLandingPage', 'true');
                history.push('/mobile/homepage');
            }
        }
        // this.refs.mainPanel.scrollTop = 0;
    }, [props.location]);

    const moveToTop = useCallback(() => {
        mainPanelRef.current.scrollTop = 0;
    }, []);

    const handleDrawerToggle = useCallback(() => {
        setMobileOpen(e => !e);
    }, [setMobileOpen]);

    const handleResize =  useCallback((e) => {
        if (window.innerWidth < 767) {
            // setDrawerOpen(false);
        } else {
            setDrawerOpen(true);
        }
    }, [setDrawerOpen]);



    const handleHeaderClick = useCallback(() => {
        setDrawerOpen(e => !e);
    }, [setDrawerOpen]);

    const handleCloseSidebar = useCallback((path) => {
        if (["/sales/dashboard", "/management/dashboard"].includes(path)) {
            setDrawerOpen(prev => !prev);
        }
    }, [setDrawerOpen]);

    const switchRoutes =  useMemo(() => {
        const tempRoutes = [];
        dashboardRoutes.forEach((prop, key) => {
            if ((user_profile.is_verified || !prop.is_protect) && prop.path ) {
                tempRoutes.push(<CustomRouter is_protect={prop.is_protect} private exact path={prop.path}
                                              component={prop.component} desktopComponent={prop.desktopComponent}
                                              key={key}
                                              {...prop}/>);
            }
        })
        return (<Switch>
            {tempRoutes}
        </Switch>)
    }, [dashboardRoutes]);

    const sideBarRoutes = useMemo(() => {
        return dashboardRoutes.filter((val, index) => {
            // if (val.roles) {
            //     if (val.roles.indexOf(Constants.ROLES.GENERAL) >= 0) {
            //         return true;
            //     }
            //     const isThere = val.roles.indexOf(role);
            //     return isThere >= 0;
            // } return true;
            return RolesUtils.canAccess(val.roles, role);
        })
    }, [dashboardRoutes, role]);

    return (
        <div ref={mainPanelRef} className={classNames(classes.wrapper,'bottomAction')}>
            <Sidebar
                routes={sideBarRoutes}
                pendingCounts={pendingCounts}
                logoText={title}
                logo={logo}
                handleDrawerToggle={handleDrawerToggle}
                toggleSideBar={handleHeaderClick}
                handleDesktoptoggle={handleCloseSidebar}
                open={drawerOpen}
                color="blue"
                {...props}
            />
            <div className={classNames(classes.appBar, {
                [classes.appBarShift]: drawerOpen,
            })}
            >
                <Header
                    handleHeaderClick={handleHeaderClick}
                    routes={dashboardRoutes}
                    handleDrawerToggle={handleDrawerToggle}
                    {...props}
                />
        <div
          className={classes.content}
          style={
            ["/messaging","/audit/group"]?.includes(window?.location?.pathname) && isMobileView
              ? { padding: "10px 0px 10px 0px" }
              : {}
          }>
          <div
            className={classes.container}
            style={
              ["/messaging","/audit/group"]?.includes(window?.location?.pathname) && isMobileView
                ? { padding: 0 }
                : {}
            }>
                        {switchRoutes}
                    </div>
                </div>
            </div>
            <FloatingChat />
            <DashboardSnackbar/>
        </div>
    );
}

export default (Dashboard);
